export {
  default as brush,
  brushX,
  brushY,
  brushSelection
} from "./src/brush";



//////////////////
// WEBPACK FOOTER
// ./~/d3/~/d3-brush/index.js
// module id = 229
// module chunks = 0 1 2 3 4